module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/logo_jpcphs-3e9e4731bde458b76686d71dff3edf8e.svg";